import script from "./stmn-pdf-prsnt-cnfm.vue?vue&type=script&setup=true&lang=js"
export * from "./stmn-pdf-prsnt-cnfm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__